import { TextAppearance, TextColor, TextSize, TextLineHeight, TextCustomProps, TextWeight } from "@vw-marketing/us-components";


export const labelTextStyle: TextCustomProps= {
    appearance: TextAppearance.headline200,
    style: {
      color: TextColor.primary,
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight24,
      fontWeight: TextWeight.regular
    }
  }
